export default "__VITE_ASSET__xKp6q4p6__"